import * as Yup from "yup"

export default function validation_dropdown(field, acc) {
  const { field_name, field_validation } = field

  const checkBool = () => {
    if (!field_validation.required) return false
    return field_validation.required[0] === "true" ? true : false
  }

  const isRequired = checkBool()
  const isRequiredTxt =
    (field_validation.required && field_validation.required[1]) ||
    "Required field."

  const isForce = field_validation.force

  if (!isRequired) return acc

  if (isForce) {
    const [match, errTxt] = field_validation.force
    return {
      [field_name]: Yup.string().required().matches(match, errTxt),
      ...acc,
    }
  }

  return {
    [field_name]: Yup.string().required(isRequiredTxt).nullable(),
    ...acc,
  }
}
